import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo']
    }
  },
  methods: {
    getWXConfig(params, getWXConfigFn, isPaper, paperArticleTitle, paperArticleUrl) {
      getWXConfigFn(params).then((res) => {
        if (res && res.data && res.status === 200) {
          //imgUrl 缩略图
          //title
          //desc
          //wxConfig:
          //signature
          //appid
          //jsapi_ticket
          //url 分享地址
          //nonceStr
          //timestamp
          if (isPaper) {
            this.setWXConfig.call(this, res.data.data, paperArticleTitle, paperArticleUrl)
          } else {
            this.setWXConfig.call(this, res.data, paperArticleTitle, paperArticleUrl)
          }
        }
      })
    },
    setWXConfig(dataForWeixin, paperArticleTitle, paperArticleUrl) {
      var that = this
      wx.config({
        debug: false,
        appId: dataForWeixin.wxConfig.appid,
        timestamp: dataForWeixin.wxConfig.timestamp,
        nonceStr: dataForWeixin.wxConfig.nonceStr,
        signature: dataForWeixin.wxConfig.signature,
        jsApiList: this.jsApiList
      })
      wx.ready(function() {
        // updateAppMessageShareData 分享qq或者朋友
        // console.log(that.setStatisticsData)
        wx.onMenuShareAppMessage({
          title: paperArticleTitle || dataForWeixin.title,
          desc: dataForWeixin.desc || '',
          link: (paperArticleUrl || window.location.href) + '&shareSour=1',
          imgUrl: window.location.protocol + dataForWeixin.imgUrl,
          trigger: function trigger(res) {},
          success: function success(res) {
            if (that.setStatisticsData) {
              that.setStatisticsData('share')
            }
          },
          cancel: function cancel(res) {},
          fail: function fail(res) {}
        })
        //监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
        // updateTimelineShareData 朋友圈qq空间
        wx.onMenuShareTimeline({
          title: paperArticleTitle || dataForWeixin.title,
          link: (paperArticleUrl || window.location.href) + '&shareSour=2',
          imgUrl: window.location.protocol + dataForWeixin.imgUrl,
          trigger: function trigger(res) {},
          success: function success(res) {
            console.log(res)
            if (that.setStatisticsData) {
              that.setStatisticsData('share')
            }
          },
          cancel: function cancel(res) {},
          fail: function fail(res) {}
        })
        //监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareQQ({
          title: paperArticleTitle || dataForWeixin.title,
          desc: dataForWeixin.desc,
          link: paperArticleUrl || window.location.href,
          imgUrl: window.location.protocol + dataForWeixin.imgUrl,
          trigger: function trigger(res) {},
          complete: function complete(res) {},
          success: function success(res) {
            if (that.setStatisticsData) {
              that.setStatisticsData('share')
            }
          },
          cancel: function cancel(res) {},
          fail: function fail(res) {}
        })
        //监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareWeibo({
          title: paperArticleTitle || dataForWeixin.title,
          desc: dataForWeixin.desc,
          link: paperArticleUrl || window.location.href,
          imgUrl: window.location.protocol + dataForWeixin.imgUrl,
          trigger: function trigger(res) {},
          complete: function complete(res) {},
          success: function success(res) {
            if (that.setStatisticsData) {
              that.setStatisticsData('share')
            }
          },
          cancel: function cancel(res) {},
          fail: function fail(res) {}
        })
      })
      wx.error(function(res) {
        console.log(JSON.stringify(res) + '微信验证失败')
      })
    }
  }
}
